import { AppPlugin } from '~/plugins/_types';
import notificationManagerInstance from '.';
import { getActions } from './notifications';

export default {
    name: 'notificationManager',
    install: async () => {
        const actions = getActions();

        notificationManagerInstance.registerBatch(actions);
    },
    priority: 3,
} satisfies AppPlugin;
